module.exports = __webpack_public_path__ + "img/29.57614b53.png";